var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-nav',{attrs:{"dashboard_title":"My Property","dashboard_route":"routes.dashboard","user":_vm.user,"routes":_vm.routes,"current":_vm.current}})
}
var staticRenderFns = []

export { render, staticRenderFns }